module.exports = __webpack_public_path__ + "img/grxx.5f4ed81d.png";